import React from "react";

import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import HCLAppscanConfigListing from "./HCLAppscanConfigListing";
import HCLAppscanCredentialsForm from "./HCLAppscanCredentialsForm";

export default function HCLAppscanPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={HCLAppscanCredentialsForm}
      PullConfigListingView={HCLAppscanConfigListing}
    />
  );
}
